module.exports = __webpack_public_path__ + "img/itx-hierarchy-6-add.cfffd8b7.svg";